// src/services/addressService.js
import api from './api';

const addressService = {
  /**
   * Get all user addresses
   * @returns {Promise<Array>} List of addresses (default first)
   */
  getUserAddresses: async () => {
    const response = await api.get('/addresses');
    return response.data;
  },

  /**
   * Get address by ID
   * @param {number} addressId - Address ID
   * @returns {Promise<Object>} Address details
   */
  getAddressById: async (addressId) => {
    const response = await api.get(`/addresses/${addressId}`);
    return response.data;
  },

  /**
   * Get default address
   * @returns {Promise<Object|null>} Default address or null
   */
  getDefaultAddress: async () => {
    const response = await api.get('/addresses/default');
    return response.data;
  },

  /**
   * Create new address
   * @param {Object} addressData - Address details
   * @returns {Promise<Object>} Created address
   * 
   * addressData: {
   *   fullName, phone, addressLine1, addressLine2,
   *   city, state, pincode, country, isDefault
   * }
   */
  createAddress: async (addressData) => {
    const response = await api.post('/addresses', addressData);
    return response.data;
  },

  /**
   * Update address
   * @param {number} addressId - Address ID
   * @param {Object} addressData - Updated address details
   * @returns {Promise<Object>} Updated address
   */
  updateAddress: async (addressId, addressData) => {
    const response = await api.put(`/addresses/${addressId}`, addressData);
    return response.data;
  },

  /**
   * Set address as default
   * @param {number} addressId - Address ID
   * @returns {Promise<Object>} Updated address
   */
  setDefaultAddress: async (addressId) => {
    const response = await api.put(`/addresses/${addressId}/default`);
    return response.data;
  },

  /**
   * Delete address
   * @param {number} addressId - Address ID
   * @returns {Promise<Object>} Success message
   */
  deleteAddress: async (addressId) => {
    const response = await api.delete(`/addresses/${addressId}`);
    return response.data;
  },
};

export default addressService;